import SKnowledgeBaseArticle from "./SKnowledgeBaseArticle_web"
export default SKnowledgeBaseArticle
